import DashboardIcon from "@mui/icons-material/SpaceDashboard";
import ListIcon from "@mui/icons-material/List";
import WorkIcon from "@mui/icons-material/Work";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import DatasetIcon from "@mui/icons-material/Dataset";
import CampaignIcon from "@mui/icons-material/Campaign";
import YouTubeIcon from "@mui/icons-material/YouTube";

// The sidebar used to be six copy-pasted <Button> blocks holding their own
// labels and their own `active === "..."` strings. Both the drawer and the
// router now read this one list, so a section cannot exist in one and not the
// other.
const adminNavigation = [
  {
    section: "Overview",
    items: [
      { key: "dashboard", label: "Dashboard", path: "/admin", icon: DashboardIcon, end: true },
    ],
  },
  {
    section: "Applications",
    items: [
      { key: "tutors", label: "Tutor Applications", path: "/admin/tutors", icon: ListIcon },
      { key: "jobs", label: "Job Placements", path: "/admin/jobs", icon: WorkIcon },
      { key: "enquiries", label: "Enquiries", path: "/admin/enquiries", icon: MarkEmailUnreadIcon },
    ],
  },
  {
    section: "Website content",
    items: [
      { key: "teachers", label: "Teachers", path: "/admin/teachers", icon: PeopleAltIcon },
      { key: "results", label: "Results", path: "/admin/results", icon: DatasetIcon },
      { key: "campaigns", label: "Campaigns", path: "/admin/campaigns", icon: CampaignIcon },
      { key: "youtube", label: "YouTube", path: "/admin/youtube", icon: YouTubeIcon },
    ],
  },
];

export const adminNavItems = adminNavigation.flatMap((group) => group.items);

export default adminNavigation;
